// extracted by mini-css-extract-plugin
module.exports = {"item":"_4148","cover":"_2144","content":"_12524","name":"_2436","info":"_18071","price":"_18557","unit":"_16956","value":"_15844","sales":"_7105"};